import { BaseTranslation } from 'src/i18n/i18n-types';

export const integrations: BaseTranslation = {
  title: 'Integrations',
  description: 'Link your accounts to get insights and manage your campaigns.',
  facebook: {
    title: 'Facebook',
    description: 'Link ad accounts to track and manage all your campaigns.',
    connectFacebook: {
      title: 'Connect',
      ctaConnectAccount: 'Connect Account',
      ctaConnect: 'Connect',
      ctaConnected: 'Connected',
      ctaModify: 'Modify',
      connectedAccounts: 'Connected Accounts',
      success: 'Successfully connected Facebook accounts: {details}',
      fail: 'Unsuccessfully in connecting Facebook accounts: {details}',
      error: 'Error connecting Facebook accounts: {error}',
      noAdAccounts:
        'No ad accounts found with the access that you need, please contact support if you think there is something wrong.',
    },
    authenticateFacebook: {
      error: 'Error authenticating Facebook: {error}',
    },
  },
  slack: {
    title: 'Slack',
    description: 'Weekly metrics sent to Slack, keeping your team informed.',
    moreInformation: {
      text: 'For more information on our Bot for Slack',
      linkText: 'see here',
    },
    connectSlack: {
      title: 'Connect',
      ctaConnect: 'Add To Slack',
      ctaConnected: 'Added To Slack',
      success: 'Successfully connected Slack workspace {details}',
      fail: 'Unsuccessfully connected Slack workspace {details}',
      error: 'Error connecting Slack workspace {error}',
    },
    disconnectSlack: {
      title: 'Disconnect Slack Workspace',
      success: 'Successfully disconnected Slack workspace',
      error: 'Error disconnecting Slack workspace {error}',
    },
  },
  youtube: {
    title: 'YouTube',
    description:
      'Link your accounts to get insights and manage your campaigns.',
    connectYoutube: {
      title: 'Connect',
      ctaConnect: 'Connect',
      ctaConnected: 'Connected',
      ctaModify: 'Modify',
      connectedAccounts: 'Connected Accounts',
      success: 'Successfully connected YouTube account {details}',
      fail: 'Unsuccessfully connected YouTube account {details}',
      error: 'Error connecting YouTube account {error}',
    },
    disconnectYoutube: {
      title: 'Disconnect YouTube accounts',
      success: 'Successfully disconnected YouTube account',
      error: 'Error disconnecting YouTube account {error}',
    },
  },
  tikTok: {
    title: 'TikTok',
    description:
      'Link your accounts to get insights and manage your campaigns.',
    connectTikTok: {
      title: 'Connect',
      ctaConnect: 'Connect',
      ctaConnected: 'Connected',
      ctaModify: 'Modify',
      connectedAccounts: 'Connected Accounts',
      success: 'Successfully connected TikTok advertiser account {details}',
      fail: 'Unsuccessfully connected TikTok advertiser account {details}',
      error: 'Error connecting TikTok advertiser account {error}',
    },
    disconnectTikTok: {
      title: 'Disconnect TikTok advertiser accounts',
      success: 'Successfully disconnected TikTok advertiser account',
      error: 'Error disconnecting TikTok advertiser account {error}',
    },
  },
  notAllowedNote: 'You must be an admin or owner',
};
